import data from "../../../../../packages/react/src/TooltipV2/Tooltip.docs.json";
import * as React from 'react';
export default {
  data,
  React
};